// extracted by mini-css-extract-plugin
export default {"date":"WlknL","year":"EP7ML","month":"-IxdD"};